import Vue from 'vue';
export class BetterVue extends Vue {
  public $route: any;
}

// tslint:disable-next-line:no-namespace
export interface ITools {
  fullscreen(): void;
  setPageDetails(config: any): void;
  guidGenerator(): string;
  isObject(value: any): boolean;
  isString(value: any): boolean;
  isNumber(value: any): boolean;
  isDate(value: any, matchString: boolean): boolean;
  isArray(value: any): boolean;
  isFunction(value: any): boolean;
  isBoolean(value: any): boolean;
  isUndefined(value: any): boolean;
  isNull(value: any): boolean;
  isNullOrUndefined(value: any): boolean;
  isSymbol(value: any): boolean;
  formatCurrency(
    amount: number | string,
    decimalPlaces?: number,
    decimalFormatter?: string,
    thousandsFormatter?: string,
    symbol?: string | boolean): string;
}


export default class Tools implements ITools {
  public dateTimeRegex = new RegExp(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]{3})Z$/)
  public fullscreen(): void {
    const windowHeight = (window as any).$(window).height();
    const headerHeight = (window as any).$('.site-header').height();
    const fitscreen = windowHeight - headerHeight;
    (window as any).$('.fullscreen').css('height', windowHeight);
    (window as any).$('.fitscreen').css('height', fitscreen);
  }
  public setPageDetails(config: any): void {
    if (config.companyName !== undefined && config.companyName !== null) {
      (window.document.getElementById('page_og_site_name') as HTMLElement).setAttribute('content', config.companyName);
    }
    if (config.title !== undefined && config.title !== null) {
      (window.document.getElementById('page_title') as HTMLElement).innerHTML = config.title;
      (window.document.getElementById('page_og_title') as HTMLElement).setAttribute('content', config.title);
    }
    if (config.keywords !== undefined && config.keywords !== null) {
      (window.document.getElementById('page_keywords') as HTMLElement).setAttribute('content', config.keywords.join(','));
    }
    if (config.description !== undefined && config.description !== null) {
      (window.document.getElementById('page_description') as HTMLElement).setAttribute('content', config.description);
      (window.document.getElementById('page_og_description') as HTMLElement).setAttribute('content', config.description);
    }
    if (config.theme !== undefined && config.theme !== null) {
      (window.document.getElementById('page_themeColour') as HTMLElement).setAttribute('content', config.theme);
      const customCssElem = window.document.getElementById('page_customCSS');
      if (customCssElem !== null) {
        customCssElem.remove();
      }
      const sheet = document.createElement('style');
      sheet.setAttribute('id', 'page_customCSS');
      sheet.innerHTML = `.service-item:hover .icon::after { background-color: ${config.theme}; } `;
      sheet.innerHTML += `.fo-color { color: ${config.theme}; }`;
      sheet.innerHTML += `.bo-color { background-color: ${config.theme}; }`;

      const specialColours = [
        {
          name: 'b-blue',
          color: '#0091ea',
        },
        {
          name: 'b-green',
          color: '#00c853',
        },
        {
          name: 'b-yellow',
          color: '#ffc400',
        },
        {
          name: 'b-red',
          color: '#ff1744',
        },
        {
          name: 'b-white',
          color: '#FFFFFF',
        },
        {
          name: 'b-dark',
          color: '#333333',
        }
      ];

      const colours = [
        {
          name: 'p-fibre',
          color: '#0268ad',
        },
        {
          name: 'p-marketing',
          color: '#ec8123',
        },
        {
          name: 'grey',
          color: '#333333',
        },
        {
          name: 'clear',
          color: '#FFFFFF',
        },
        {
          name: 'core',
          color: 'rgb(0, 145, 234)',
        },
        {
          name: 'internal',
          color: 'rgb(0, 200, 83)',
        },
        {
          name: 'hardware',
          color: 'rgb(255, 23, 68)',
        },
        {
          name: 'services',
          color: 'rgb(255, 196, 0)',
        }
      ];
      let rootVars: Array<string> = [];
      for (let col of specialColours) {
        colours.push(col);
        rootVars.push(`${col.name}:${col.color}`);
      }
      sheet.innerHTML += `:root { ${rootVars.join(';')} }`;

      for (const col of colours) {
        sheet.innerHTML += `.btn-${col.name} { background-color: ${col.color}; color: #FFFFFF; } ` +
          `.btn-${col.name}:hover, .hoverDarkLight:not(:hover) .btn-${col.name} { background-color: rgba(158,158,158,.2); color: ${col.color}; } ` + 
          `.hoverDarkLight:hover .btn-${col.name} { background-color: ${col.color} !important; color: #FFFFFF !important; } `;
        sheet.innerHTML += `.fo-color-${col.name} { color: ${col.color}; }`;
        sheet.innerHTML += `.bo-color-${col.name} { background-color: ${col.color}; }`;
        sheet.innerHTML += `.slick-dots-color-${col.name} li { border-color: ${col.color} !important; }`;
        sheet.innerHTML += `.service-item-${col.name} .service-item:hover .icon::after { background-color: ${col.color}; }`;
        sheet.innerHTML += `.slick-dots-color-${col.name} ` +
          `li.slick-active button { background-color: ${col.color} !important; }`;
      }

      document.head.appendChild(sheet);
    }
    if (config.icons !== undefined && config.icons !== null) {
      for (const iconSize of Object.keys(config.icons)) {
        (window.document.getElementById(`page_icon${iconSize}`) as HTMLElement)
          .setAttribute('href', config.icons[iconSize]);
        (window.document.getElementById(`page_icon${iconSize}`) as HTMLElement)
          .setAttribute('content', config.icons[iconSize]);
      }
    }
    let bgStyleAttr = (window.document.getElementsByTagName('body')[0] as HTMLElement).getAttribute('style');
    if (bgStyleAttr === undefined || bgStyleAttr === null)
      bgStyleAttr = '';
    let bgStyle = `${bgStyleAttr}`.split(';');
    for (let ix = 0; ix < bgStyle.length; ix++) {
      if (bgStyle[ix].trim().indexOf('background:') === 0) {
        bgStyle.splice(ix, 1);
        break;
      }
    }
    console.log(config)
    if (config.docBackgroundColour !== undefined && config.docBackgroundColour !== null)
      bgStyle.push(`background: ${config.docBackgroundColour}`);
    (window.document.getElementsByTagName('body')[0] as HTMLElement).setAttribute('style', bgStyle.join(';'));
  }
  public guidGenerator(): string {
    const S4 = () => {
      // tslint:disable-next-line:no-bitwise
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (`${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
  }
  public isObject(value: any): boolean {
    return value && typeof value === 'object' && value.constructor === Object;
  }
  public isString(value: any): boolean {
    return typeof value === 'string' || value instanceof String;
  }
  public isNumber(value: any): boolean {
    return typeof value === 'number' || !isNaN(value);
  }
  public isDate(value: any, matchString: boolean = true): boolean {
    return value instanceof Date
      ? true
      : matchString
        ? this.dateTimeRegex.test(`${value}`)
        : false;
  }
  public isArray(value: any): boolean {
    return value && typeof value === 'object' && value.constructor === Array;
  }
  public isFunction(value: any): boolean {
    return typeof value === 'function';
  }
  public isBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }
  public isUndefined(value: any): boolean {
    return typeof value === 'undefined';
  }
  public isNull(value: any): boolean {
    return value === null;
  }
  public isNullOrUndefined(value: any): boolean {
    return this.isUndefined(value) || this.isNull(value);
  }
  public isSymbol(value: any): boolean {
    return typeof value === 'symbol';
  }
  public formatCurrency(
    amount: number | string,
    decimalPlaces?: number,
    decimalFormatter?: string,
    thousandsFormatter?: string,
    symbol?: string | boolean): string {
    decimalPlaces = this.isNullOrUndefined(decimalPlaces) ? 2 : Math.abs(decimalPlaces as number);
    decimalFormatter = this.isNullOrUndefined(decimalFormatter) ? '.' : decimalFormatter;
    thousandsFormatter = this.isNullOrUndefined(thousandsFormatter) ? ' ' : thousandsFormatter;
    if (!this.isNumber(amount)) {
      amount = Number.parseFloat(amount as string);
    }

    const negative = (amount < 0 ? '-' : '');
    amount = Math.abs(amount as number || 0);
    amount = amount.toFixed(decimalPlaces);
    if (!this.isNullOrUndefined(symbol)) {
      if (this.isBoolean(symbol) && symbol === false) {
        symbol = '';
      } else {
        symbol = 'R';
      }
    } else {
      symbol = 'R';
    }
    const numberValueSplit = amount.split('.')
    let decimalValue = ''
    if (decimalPlaces > 0) {
      decimalValue = decimalFormatter + numberValueSplit[1];
    }

    return symbol
      + ' ' + negative
      + numberValueSplit[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsFormatter as string)
      + decimalValue;
  }
}
